import Icon from "~/components/ui/Icon"
import { AvailableIcons } from "~/components/ui/Icon"

export interface Shortcut {
    /**
     * @title Texto
     */
    label?: string
    /**
     * @title Ícone
     */
    icon?: AvailableIcons
    /**
     * @title Link
     */
    link?: string
}

export interface Props {
    /**
     * @title Atalhos
     */
    shortcuts?: Shortcut[]
    /**
     * @title Ao passar o mouse
     */
    onHover?: 'Mostrar Texto' | 'Mostrar Tooltop'
}

export default function Shortcuts({ shortcuts, onHover }: Props) {
    return (
        <div className='group fixed flex flex-col top-1/2 right-0 z-20'>
            {shortcuts?.map((shortcut) => {
                return (
                    <a
                        href={shortcut.link}
                        target='_blank'
                        className={`flex items-center h-10 bg-base-100 text-base-content hover:bg-base-content hover:text-base-100 border-2 border-neutral mt-[-2px] ${
                            onHover === 'Mostrar Tooltop' && 'tooltip tooltip-left'
                        }`}
                        data-tip={shortcut.label}
                        rel='noreferrer'
                    >
                        <div className='w-10 flex justify-center'>
                            {shortcut.icon && <Icon id={shortcut.icon} size={24} />}
                        </div>
                        {(!onHover || onHover === 'Mostrar Texto') && (
                            <div className='flex-none max-w-0 lg:group-hover:max-w-[200px] lg:group-hover:w-auto lg:group-hover:pr-2 duration-200'>
                                {shortcut.label}
                            </div>
                        )}
                    </a>
                )
            })}
        </div>
    )
}
export { default as LoadingFallback } from "~/components/LoadingFallback"
